<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les soirées théologiques" />
            <LesSoireestheologiques />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesSoireestheologiques from './LesSoireestheologiques.vue';


export default {
    name: 'LesResponsablesPage',
    components: {
        NavBar,
        PageTitle,
        LesSoireestheologiques,
        FooterComp,
    }
}
</script>